// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3wG7b","header":"MessagesList_header__1M90T","chat":"MessagesList_chat__YsdYA"};